export default {
  registrationReview: "/register/review/",
  confirmEmail: "/confirm-email",
};
